import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';

const ResueableSibebar = ({ isVisible, setIsVisible, children, position = 'right', title = '', HeaderIcon = null }) => {
  const renderHeader = () => (
    <div className='flex justify-between align-items-center'>
      <div className='flex items-center'>
        {HeaderIcon && (
          <div className='icon-bg-container me-2'>
            <HeaderIcon size={20} className='text-primary' />
          </div>
        )}
        <h5 className='text-darkBg  text-[16px] md:text-[18px] lg:text-[20px] font-[600]'>{title}</h5>
      </div>
    </div>
  );
  return (
    <div className=''>
      <Sidebar
        position={position}
        header={renderHeader()}
        visible={isVisible}
        onHide={() => setIsVisible(false)}
        pt={{
          header: {
            className:
              'flex items-center justify-between border-b border-gray-200 text-darkBg text-[16px] lg:text-[18px] xl:text-[20px] font-[600]'
          },
          root: {
            className: 'w-full md:w-[350px] lg:w-[450px] xl:w-[500px]'
          },
          content:{className:"!p-2"}
        }}
      >
        {children}
      </Sidebar>
    </div>
  );
};

export default ResueableSibebar;
